/**
 * profileService.js
 * Client-Service für User-Profile API
 *
 * Kommuniziert mit dem Backend für Profil-Operationen.
 */

const API_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';

/**
 * Holt das eigene Profil (erstellt es bei erstem Login)
 * @param {string} authToken - JWT Token von Dynamic
 */
export async function getProfile(authToken) {
  const response = await fetch(`${API_URL}/api/profile`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${authToken}`,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }

  return response.json();
}

/**
 * Aktualisiert das eigene Profil
 * @param {string} authToken - JWT Token von Dynamic
 * @param {object} updates - { nickname?, deck_design? }
 */
export async function updateProfile(authToken, updates) {
  const response = await fetch(`${API_URL}/api/profile`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${authToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }

  return response.json();
}

/**
 * Holt alle verfügbaren Deck-Designs
 */
export async function getDeckDesigns() {
  const response = await fetch(`${API_URL}/api/profile/decks`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return response.json();
}

/**
 * Holt vollständige Statistiken (profiles + badge_stats)
 * @param {string} authToken - JWT Token
 */
export async function getFullStats(authToken) {
  const response = await fetch(`${API_URL}/api/profile/stats/full`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${authToken}`,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }

  return response.json();
}

/**
 * Löscht den eigenen Account
 * @param {string} authToken - JWT Token
 */
export async function deleteAccount(authToken) {
  const response = await fetch(`${API_URL}/api/profile`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${authToken}`,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }

  return response.json();
}

